import React, { useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import { NavButtonsContextProvider } from 'Components/ClientApp/CombinedApp/Navigation/NavButtonsContext';
import {
  FDBox, FDFacetLogo, FDIcon, FDStack,
} from '@facet-wealth/design';
import { NotificationsNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Notifications';
import MuiToolbar from '@material-ui/core/Toolbar';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { MOBILE_MENU_FROM_BOTTOM } from 'Context/LayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { DrawerClientNavPicker } from './DrawerClientNavPicker';
import { useDashboardPath } from '../useDashboardPath';

const useStyles = buildUseStyles('BottomNavDrawer', (theme) => ({
  root: {
    zIndex: `${theme.zIndex.appBar} !important`, // MUI is setting the z-index on the element directly
  },
  paper: {
    height: '100vh',
    paddingBottom: theme.heights.mobileBottomNavigationHeight,
  },
}));

export function BottomNavDrawer({ open, from, onClose }) {
  const classes = useStyles();
  const { location } = useHistory();

  // Whenever the URL bar changes, close the menu (for example, hitting the browser's back button to pop URL state should close the menu).
  // It looks like url is an unnecessary construction and location can be used directly, but that's not the case for a few reasons:
  // 1. Sometimes location changes for other reasons (e.g. the location's state or key)
  // 2. Even if you used location.pathname and location.search, sometimes location.search changes from an empty string to a ?
  const url = location.pathname + (location.search === '?' ? '' : location.search);
  useEffect(() => {
    onClose();
  }, [url, onClose]);

  // If you open the drawer, then switch to desktop layout, the drawer should be closed
  const isMobile = useMobileLayout();
  useEffect(() => {
    if (!isMobile) onClose();
  }, [isMobile, onClose]);

  const { dashboardPath } = useDashboardPath();

  return (
    <Drawer anchor="bottom" open={open} onClose={onClose} classes={{ root: classes.root, paper: classes.paper }}>
      <NavButtonsContextProvider>
        <MuiToolbar disableGutters={from !== MOBILE_MENU_FROM_BOTTOM}>
          <FDStack flexGrow={1} justifyContent="space-between" alignItems="center">
            {from === MOBILE_MENU_FROM_BOTTOM ? (
              <Link to={dashboardPath}>
                <FDBox paddingY={3}>
                  <FDFacetLogo size="md" />
                </FDBox>
              </Link>
            ) : (
              <IconButton onClick={onClose} icon={FDIcon} IconProps={{ icon: 'menu', color: 'white' }} />
            )}
            <NotificationsNavButton />
          </FDStack>
        </MuiToolbar>
        <DrawerClientNavPicker />
      </NavButtonsContextProvider>
    </Drawer>
  );
}

BottomNavDrawer.defaultProps = {
  from: null,
};

BottomNavDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  from: PropTypes.string,
};
